import Vue from "vue";
import vueFilters from "./vue-filters";
import { addToCart } from "./request";

export default function init() {
    var el = document.getElementById("birth-list-app");
    if (!el) return;
    var token = el.getAttribute("data-token");
    var birthListId = el.getAttribute("data-birth-list-id");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            loading: true,
            submitting: false,
        },
        mounted: async function () {},
        computed: {},
        methods: {
            addToCart: async function (item, e) {
                var count = e.target.parentNode.querySelector("select").value;
                if( parseInt(count) > 0) {
                    this.loading = true;
                    window.cart.addToCart(item, parseInt(count), [], null, '', birthListId);
                    this.loading = false;
                    window.openCartPopup();
                    window.scrollTo(0, 0);
                }
            },
        },
        watch: {},
    });
}
